
import { BaseModulePublicApi, addAuthToHeader } from "../../base/BaseModulePublicApi";

export class PublicUserTicketsApi extends BaseModulePublicApi {
  basePath = 'my_tickets';


  // Generate QR
  async generateQR(ticket_id: string, headers: any, configOptions?: any) {
    const response = await this.axiosInstance!.get(`/front/${this.domain}/${this.basePath}/${ticket_id}/generate_qr`, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };
};
